import { IGNORE_BLUR_CLASS } from 'core-components/library/dropdown/constants'

import { IDropdownProps } from '../models/IDropdownProps'

import { CreateItem } from './newItemButton/CreateItem'

interface INewItemButton {
  createItemTemplate?: IDropdownProps['createButtonTemplate']
  onClick: () => void
}

export const NewItemButton = ({ createItemTemplate, onClick }: INewItemButton) => {
  const properties = { onClick, className: IGNORE_BLUR_CLASS }

  if (createItemTemplate) {
    return createItemTemplate(properties)
  }

  return <CreateItem {...properties} />
}
